var exports = {
  "e6": "ChannelItem.module__channelItemCore___MkREUE",
  "$H": "ChannelItem.module__channelItemCoreSelected___MkREUE",
  "_B": "ChannelItem.module__channelItemCoreUnselected___MkREUE",
  "Vp": "ChannelItem.module__channelItemCoreHovered___MkREUE",
  "TV": "ChannelItem.module__typingTooltip___MkREUE",
  "kp": "ChannelItem.module__channelTypingIndicator___MkREUE",
  "IM": "ChannelItem.module__typingIndicatorIcon___MkREUE",
  "U4": "ChannelItem.module__channelItemSelected___MkREUE",
  "OI": "ChannelItem.module__typingAvatars___MkREUE",
  "_N": "ChannelItem.module__channelItemIcon___MkREUE",
  "Jz": "ChannelItem.module__channelItemIconSelected___MkREUE",
  "Wk": "ChannelItem.module__categoryContainer___MkREUE",
  "yb": "ChannelItem.module__categoryName___MkREUE",
  "zc": "ChannelItem.module__iconContainer___MkREUE",
  "HA": "ChannelItem.module__channelName___MkREUE",
  "Hq": "ChannelItem.module__actionsContainer___MkREUE",
  "OO": "ChannelItem.module__channelItemIconUnselected___MkREUE",
  "Cr": "ChannelItem.module__channelItemIconHighlight___MkREUE",
  "rC": "ChannelItem.module__channelItemLabel___MkREUE",
  "gw": "ChannelItem.module__channelItemActions___MkREUE",
  "kL": "ChannelItem.module__container___MkREUE",
  "YI": "ChannelItem.module__channelReorderTarget___MkREUE",
  "c2": "ChannelItem.module__channelCategoryReorderTarget___MkREUE",
  "XE": "ChannelItem.module__unreadIndicator___MkREUE",
  "_j": "ChannelItem.module__unreadIndicatorMuted___MkREUE",
  "fc": "ChannelItem.module__channelItem___MkREUE",
  "Z$": "ChannelItem.module__channelItemCategory___MkREUE",
  "RQ": "ChannelItem.module__channelItemRegular___MkREUE",
  "zx": "ChannelItem.module__channelItemHighlight___MkREUE",
  "_R": "ChannelItem.module__channelItemMuted___MkREUE",
  "Td": "ChannelItem.module__channelItemSelectedWithUnread___MkREUE",
  "Fb": "ChannelItem.module__channelItemHoverable___MkREUE",
  "FN": "ChannelItem.module__channelItemPressed___MkREUE",
  "Je": "ChannelItem.module__channelItemOver___MkREUE",
  "X9": "ChannelItem.module__channelItemContextMenu___MkREUE",
  "L5": "ChannelItem.module__channelItemCategoryContextMenu___MkREUE",
  "GJ": "ChannelItem.module__channelItemDragging___MkREUE",
  "rO": "ChannelItem.module__channelItemDimmed___MkREUE",
  "x1": "ChannelItem.module__channelItemMutedState___MkREUE",
  "Ef": "ChannelItem.module__hoverAffordance___MkREUE",
  "Mn": "ChannelItem.module__keyboardFocus___MkREUE",
  "BE": "ChannelItem.module__channelItemAutocompleteHighlight___MkREUE",
  "Yq": "ChannelItem.module__categoryContent___MkREUE",
  "Yl": "ChannelItem.module__categoryIcon___MkREUE",
  "Sk": "ChannelItem.module__createChannelButton___MkREUE",
  "$Z": "ChannelItem.module__createChannelIcon___MkREUE",
  "Ne": "ChannelItem.module__voiceUserCount___MkREUE",
  "p9": "ChannelItem.module__channelItemVoice___MkREUE",
  "pL": "ChannelItem.module__contextMenuOpen___MkREUE",
  "jL": "ChannelItem.module__channelItemHoverAffordancesActive___MkREUE",
};

module.exports = exports;
